import { connect } from 'react-redux'
import { authenticate } from '../../../modules/actions/session'
import { getAccessToken } from '../../../modules/selectors/session';

import Login from '../components/Login';

const mapStateToProps = (state) => ({
  loggedIn: !!getAccessToken(state)
});

const mapDispatchToProps = {
  authenticate
};

const mergeProps = (stateProps, dispatchProps, parentProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...parentProps,
  redirectUri: (parentProps.location
  && parentProps.location.query
  && parentProps.location.query.redirect) || '/',
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Login)
